import React, { CSSProperties } from 'react';
import { FileError, FileRejection, useDropzone } from 'react-dropzone';
import { DragZone } from './FileInputStyled';

interface DropProps {
  accept?: string[];
  multiple?: boolean;
  validator?: <T extends File>(file: T) => FileError | FileError[] | null;
}

export interface FileProps {
  onChange?: (value: File[]) => void;
  onError?: (error: FileRejection[]) => void;
  style?: CSSProperties;
  dropProps?: DropProps;
  children?: React.ReactElement<React.PropsWithChildren<{}>>;
  disabled?: boolean;
}

const FileInput = ({ onError, onChange, children, ...props }: FileProps) => {
  const handleDrop = (files: File[]) => {
    onChange?.(files);
  };
  const handleDropRejected = (files: FileRejection[]) => {
    onError?.(files);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    onDropRejected: handleDropRejected,
    disabled: props.disabled ?? false,
    ...(props.dropProps ? props.dropProps : {}),
  });

  return (
    <DragZone style={props.style} active={isDragActive} {...getRootProps()}>
      <input type="file" hidden {...getInputProps()} />
      {children}
    </DragZone>
  );
};

export default FileInput;
